import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CofagSimulationRequest } from '../models/cofag-simulation-request';
import { CofagSimulationResponse } from '../models/cofag-simulation-response.model';

@Injectable({
  providedIn: 'root',
})
export class CofagSimulationService {
  private readonly http = inject(HttpClient);

  public postCofagSimulation(
    cofagSimulationRequest: Partial<CofagSimulationRequest>,
  ): Observable<CofagSimulationResponse> {
    return this.http.post<CofagSimulationResponse>(
      '/rgg/fis/v1/cofag-simulation',
      cofagSimulationRequest,
    );
  }
}
